'use strict';

var debug = require('debug');

function createLogger(name) {
  var logger = debug(name);

  return function (message) {
    logger(message);
  };
}

module.exports = createLogger;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-util-logger/lib/createLogger.js
// module id = 651
// module chunks = 0